module.exports = __webpack_public_path__ + "static/22-a45e3206c9dd6914c49e6a575c35c0fc.jpg";